<template>
  <div class="index" id="index">
    <!-- 课程首页 -->
    <app-header v-if="header_show"></app-header>
    <div class="tabbar">
      <div style="width: 1rem;height: 100%;float: left;"> </div>
      <router-link tag="div" active-class="checked" class="list" v-for="(item,index) in tabbar" :key="index" :to="'/' + item.id">
          {{item.name}}
          <div class="line"></div>
      </router-link>
      <div data-v-35e43fcf="" class="list">
       <!--<a href="https://www.wjx.cn/jq/95396701.aspx" style="text-decoration:none;" target="_blank">调查问卷</a>-->
      <div data-v-35e43fcf="" class="line"></div></div>

     <!-- <div :class="(item.checked ? 'list checked' : 'list')" v-for="(item,index) in tabbar" :key="index" @click="changeTab(index);">
        {{item.name}}
        <div class="line" v-if="item.checked"></div>
      </div> -->
    </div>
    <div class="" style="min-height: 600px;">
       <router-view />
      <!-- <course v-if="tabbar[0].checked"></course>
      <eval v-if="tabbar[1].checked"></eval>
      <cert v-if="tabbar[2].checked"></cert>
      <achieve v-if="tabbar[3].checked"></achieve> -->
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'index',
  data () {
    return {
      header_show:true,
      tabbar:[
        {name:'我的课程',id:'Course',checked:true},
        // {name:'项目测评',id:'Eval',checked:false},
        // {name:'研修总结',id:'Sumup',checked:false},
        // {name:'我的证书',id:'Cert',checked:false},
        {name:'我的成就',id:'Achieve',checked:false},
      ],
    }
  },
  components:{
    'app-header':Header
  },
  mounted() {
    var _this = this;
    var token = localStorage.getItem('token');
    if(!token){
       this.$router.replace({path:'/login'});
       return;
    }
    this.event = JSON.parse(localStorage.getItem('event'));
    this.config = JSON.parse(localStorage.getItem('config'));
    if (this.config.isReport==1) {
      this.tabbar=[
        // {name:'我的证书',id:'Cert',checked:false},
        {name:'我的课程',id:'Course',checked:true},
        // {name:'项目测评',id:'Eval',checked:false},
        {name:'研修总结',id:'Sumup',checked:false},
         {name:'我的证书',id:'Cert',checked:false},
        {name:'我的成就',id:'Achieve',checked:false},
      ]
    }
    this.post('/trainee/info',{},(data)=>{
      localStorage.setItem('userinfo',JSON.stringify(data.data));
      console.log(data);
    })

  },
  methods:{
    header:function (bool) {
      this.header_show = bool;
    },
    changeTab(index){
      this.tabbar.forEach((v,k)=>{
        if(index == k){
          if(!v.checked){
             v.checked = true;
          }
        }else{
          v.checked = false;
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index{

}
.tabbar{
  /* width: 14.5rem; */
  width: 100%;
  height: 0.9rem;
  margin: 0 auto;
  border-bottom: 0.02rem solid #797979;
}
.list{
  height: 100%;
  font-size: 0.32rem;
  color: #000;
  float: left;
  margin-right: 0.56rem;
  line-height: 0.9rem;
  position: relative;
  cursor: pointer;
}
.checked{
  color: #0073d2;
}
.checked .line{
  width: 1.25rem;
  height: 0.06rem;
  background-color: #0073d2;
  position: absolute;
  left: 50%;
  bottom: 0.1rem;
  transform: translate(-50%,0);
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue